module.exports = __webpack_public_path__ + "img/raid.f2c0d0ad.svg";